import api from '@/services/api/api';

export const useAuthorContent = (slug, model) => {
  const authorContent = useInfiniteQuery(
    ['authorContent', slug, model],
    async ({ pageParam = 1 }) => {
      const { data } = await api.authors.getAuthorsContent(
        slug,
        toValue(model),
        {
          page: pageParam,
        },
      );

      return data;
    },
    {
      enabled: computed(() => !!toValue(model)),
      staleTime: Infinity,
      select: ({ pages }) => pages.flatMap((data) => data?.data),
      getNextPageParam: (data) => {
        return data.meta.current_page < data.meta.last_page
          ? data.meta.current_page + 1
          : undefined;
      },
      refetchOnMount: true,
    },
  );

  const queryClient = useQueryClient();

  const resetPage = (filters) => {
    queryClient.setQueryData(['authorContent', filters], (prevData) => {
      if (!prevData) return;
      return {
        pages: [prevData.pages[0]],
        pageParams: [prevData.pageParams[0]],
      };
    });
  };

  onServerPrefetch(async () => {
    if (!toValue(model)) return;
    await authorContent.suspense();
  });

  return {
    authorContent,
    resetPage,
  };
};
